/**
* A simple loop to throttle bound callbacks.
*
* @param var timeoutFunc A var to which the setTimeout method must be passed.
* @param var timeout The delay in milliseconds for the timeout.
* @param object cb The callback method to run after the throttle + timeout.
*
* @return object setTimeout method.
*/
export const throttle = (timeoutFunc, timeout, cb) => {
  clearTimeout(timeoutFunc);
  return setTimeout(() => { cb(); }, timeout);
}
